import { Tax } from './Tax';
import { Fee } from './Fee';
import { ContextualPricing } from './ContextualPricing';
import { Donation } from './Donation';
import { UpsellGroup } from './UpsellGroup';

export class BasketValidation {
    basketid: string;
    contextualpricing: ContextualPricing;
    tax: number;
    taxes: Array<Tax>;
    customerhandoffcharge: number;
    fees: Array<Fee>;
    donations: Array<Donation>;
    subtotal: number;
    total: number;
    readytime: string;
    totalfees: number;
    totaldonations: number;
    upsellgroups?: UpsellGroup;

    public static Make(obj: any): BasketValidation {
        const basketValidation = new BasketValidation();
        Object.assign(basketValidation, obj);
        return basketValidation;
    }
}
